import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const Root = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  background: "#fafafa",
  borderRadius: "10px",
  maxWidth: "300px",
  margin: "10px auto",
  maxHeight: "300px", // Set a maximum height for the container
  overflowY: "auto", // Enable vertical scrolling
  border: "1px solid #e0e0e0",
}));

const Heading = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(1),
  fontSize: "1rem",
  color: "#333",
}));

const Card = styled(Paper)(({ theme }) => ({
  background: "#fff",
  border: "1px solid #e0e0e0",
  borderRadius: "5px",
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const CardText = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  color: "#555",
}));

const RepairMaintenanceComponent = ({ data }) => {
  return (
    <Root elevation={3}>
      <Heading variant="h6">Repair and Maintenance</Heading>
      <Grid container spacing={1}>
        {data.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Card>
              <CardText variant="subtitle1" gutterBottom>
                {item.date}
              </CardText>
              <CardText variant="body2">{item.text}</CardText>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Root>
  );
};

export default RepairMaintenanceComponent;
